import { request } from './http';

export async function getFlowMeterLogs(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.filter) {
      queryParams.append('filter', JSON.stringify(params.filter));
    }
    const wantsPage = params.page != null || params.limit != null || params.offset != null;
    if (!wantsPage) {
      queryParams.append('all', '1');
    } else {
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.offset != null) queryParams.append('offset', params.offset);
    }
    if (params.sort) queryParams.append('sort', params.sort);
    else queryParams.append('sort', '-DueDate');
    if (params.select) queryParams.append('select', params.select);
    return request(`/data/FlowMeterLogs?${queryParams.toString()}`);
  }

export async function createFlowMeterLog(logData) {
    return request('/data/FlowMeterLogs', {
      method: 'POST',
      body: JSON.stringify(logData)
    });
  }

export async function updateFlowMeterLog(id, logData) {
    return request(`/data/FlowMeterLogs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(logData)
    });
  }

export async function deleteFlowMeterLog(id) {
    return request(`/data/FlowMeterLogs/${id}`, {
      method: 'DELETE'
    });
  }

export const flowMeterLogsApi = {
  getFlowMeterLogs,
  createFlowMeterLog,
  updateFlowMeterLog,
  deleteFlowMeterLog,
};

